import React from 'react';
import { theme } from '@admitkard/ccl/style';
import { Text } from '@admitkard/ccl/Text';
import { Button } from '@admitkard/ccl/Button';
import { Icon } from '@admitkard/ccl/Icon';
import Link from 'next/link';

export interface PackageDetailsObject {
  title: string;
  description: string;
}

export interface PackageDetailsProps {
  packageName: string;
  packagePrice: string;
  packageDescription: string;
  packageDetails: PackageDetailsObject[];
  buttonText: string;
  buttonHref: string;
}

const styles = `
  .package-details_container {
    background-color: ${theme.palette.common.white};
    border-radius: ${theme.shape.borderRadius};
    padding: ${theme.spacingOld(6)} ${theme.spacingOld(5)};
    width: 18rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    box-shadow: ${theme.shadows[4]};
  }
  .package-details_package-name {
    font-size: 2.25rem;
    margin-bottom: ${theme.spacingOld(5)};
  }
  .package-details_package-price {
    margin-bottom: ${theme.spacingOld(3)};
    font-size: ${theme.fontSize.xxxl};
  }
  .package-details_pricing-description {
    margin-bottom: ${theme.spacingOld(6)};
  }
  .package-details_package-point {
    display: flex;
  }
  .package-details_package-point-icon-container {
    margin-right: ${theme.spacingOld(3)};
  }
  .package-details_package-points-container {
    margin-top: ${theme.spacingOld(7)};
  }
  .package-details_package-point-text-container {
    margin-bottom: ${theme.spacingOld(5)};
  }
  .package-details_package-point-title {
    margin-bottom: ${theme.spacingOld(2)};
  }
  .package-details_package-point-description {
    font-size: ${theme.fontSize.xxs};
  }
  @media only screen and (min-width: 1024px) {
    .package-details_container {
      height: 57rem;
    }
    .package-details_pricing-description {
      min-height: 3rem;
    }
  }
  @media only screen and (min-width: 1440px) {
    .package-details_container {
      width: 21rem;
    }
    .package-details_pricing-description {
      min-height: 2rem;
    }
    .package-details_container {
      height: 54rem;
    }
  }
`;

const PackageDetails: React.FunctionComponent<PackageDetailsProps> = (props) => {
  const { packageName, packagePrice, packageDescription, buttonHref, buttonText, packageDetails } = props;
  const packageDetailsList = packageDetails.map((packagePoints) => {
    return (
      <div key={packagePoints.title} className="package-details_package-point">
        <div className="package-details_package-point-icon-container">
          <Icon name="circle_checkmark" size="large" />
        </div>
        <div className="package-details_package-point-text-container">
          <Text display="block" weight="bold" className="package-details_package-point-title" variant="s">
            {packagePoints.title}
          </Text>
          <Text display="block" lightness={9} className="package-details_package-point-description">
            {packagePoints.description}
          </Text>
        </div>
      </div>
    );
  });
  return (
    <div className="package-details_container">
      <Text display="block" align="center" weight="bold" className="package-details_package-name">
        {packageName}
      </Text>
      <Text display="block" align="center" weight="bold" className="package-details_package-price">
        <sup>&#8377;</sup>
        {packagePrice}
      </Text>
      <Text display="block" align="center" lightness={8} weight="bold" variant="s" className="package-details_pricing-description">
        {packageDescription}
      </Text>
      <Link href={buttonHref} as={buttonHref}>
        <Button color="primary" variant="contained">
          {buttonText}
        </Button>
      </Link>
      <div className="package-details_package-points-container">{packageDetailsList}</div>
      <style>{styles}</style>
    </div>
  );
};

export default PackageDetails;
